/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    GroupType,
} from './';

/**
 * @export
 * @interface GroupCreateFields
 */
export interface GroupCreateFields {
    /**
     * Names String. For example zone name, group name or custom_id
     * @type {string}
     * @memberof GroupCreateFields
     */
    name: string;
    /**
     * `Zone Primary Key`
     * @type {number}
     * @memberof GroupCreateFields
     */
    zone_id: number;
    /**
     * @type {GroupType}
     * @memberof GroupCreateFields
     */
    type?: GroupType;
    /**
     * Names String. For example zone name, group name or custom_id
     * @type {string}
     * @memberof GroupCreateFields
     */
    custom_id?: string;
    /**
     * `Level Primary Key`
     * @type {number}
     * @memberof GroupCreateFields
     */
    level_id?: number;
}
